import Vue from 'vue'
import * as LtngComponents from '@greyskymedia/ltng-components'
import '@greyskymedia/ltng-components/dist/ltng.css'

for (const componentName in LtngComponents) {
  Vue.component(`Ltng${componentName}`, LtngComponents[componentName])
}
